module.exports = {
    carData: () => {
        return[
            {
                "NUEVO HB20": {
                    "Nombre": "NUEVO HB20",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://view.genial.ly/637406c6af501d0017835285"
                        },
                        {
                            "Nombre":"Video de producto",
                            "Icono": require('./../UI/canvas/carmenu/promocionales.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/promocionales_white.svg'),
                            "Slug":"promocionales",
                            "URL":"https://www.youtube.com/embed/uz0pxz2OG7Y"
                        },
                        {
                            "Nombre":"Testimoniales",
                            "Icono": require('./../UI/canvas/carmenu/testimonial.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/testimonial_white.svg'),
                            "Slug":"testimoniales",
                            "URL":"https://www.youtube.com/embed/ZOVyJGt6oMQ"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://www.hyundaicolombia.co/cotizador"
                        },
                        {
                            "Nombre":"Test Drive",
                            "Icono": require('./../UI/canvas/carmenu/test_drive.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/test_drive_white.svg'),
                            "Slug":"testdrive",
                            "URL":"https://www.hyundaicolombia.co/testdrive"
                        }
                    ]
                },

                "NUEVO HB20S": {
                    "Nombre": "NUEVO HB20S",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://view.genial.ly/639b2869dc718e0019065f30"
                        },
                        {
                            "Nombre":"video de producto",
                            "Icono": require('./../UI/canvas/carmenu/promocionales.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/promocionales_white.svg'),
                            "Slug":"promocionales",
                            "URL":"https://www.youtube.com/embed/Fg3JwqCDGmU"
                        },
                        {
                            "Nombre":"Testimoniales",
                            "Icono": require('./../UI/canvas/carmenu/testimonial.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/testimonial_white.svg'),
                            "Slug":"testimoniales",
                            "URL":"https://www.youtube.com/embed/_9hVpPrHdwU"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://www.hyundaicolombia.co/cotizador"
                        },
                        {
                            "Nombre":"Test Drive",
                            "Icono": require('./../UI/canvas/carmenu/test_drive.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/test_drive_white.svg'),
                            "Slug":"testdrive",
                            "URL":"https://www.hyundaicolombia.co/testdrive"
                        }
                    ]
                },

                "HB20X ADVANCE": {
                    "Nombre": "HB20X ADVANCE",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://view.genial.ly/61fd8276edbe3100122e1aae"
                        },
                        {
                            "Nombre":"video de producto",
                            "Icono": require('./../UI/canvas/carmenu/promocionales.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/promocionales_white.svg'),
                            "Slug":"promocionales",
                            "URL":"https://www.youtube.com/embed/qHqoZWCH5HU"
                        },
                        {
                            "Nombre":"Testimoniales",
                            "Icono": require('./../UI/canvas/carmenu/testimonial.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/testimonial_white.svg'),
                            "Slug":"testimoniales",
                            "URL":"https://www.youtube.com/embed/DZKUt04HZ9E"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://www.hyundaicolombia.co/cotizador"
                        },
                        {
                            "Nombre":"Test Drive",
                            "Icono": require('./../UI/canvas/carmenu/test_drive.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/test_drive_white.svg'),
                            "Slug":"testdrive",
                            "URL":"https://www.hyundaicolombia.co/testdrive"
                        }
                    ]
                },

                "KONA PREMIUM": {
                    "Nombre": "KONA PREMIUM",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://view.genial.ly/61ce0fb224849a0d65085168"
                        },
                        {
                            "Nombre":"video de producto",
                            "Icono": require('./../UI/canvas/carmenu/promocionales.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/promocionales_white.svg'),
                            "Slug":"promocionales",
                            "URL":"https://www.youtube.com/embed/hlDDY127mHM"
                        },
                        {
                            "Nombre":"Testimoniales",
                            "Icono": require('./../UI/canvas/carmenu/testimonial.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/testimonial_white.svg'),
                            "Slug":"testimoniales",
                            "URL":"https://www.youtube.com/embed/HsDL7y5-Dpo"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://www.hyundaicolombia.co/cotizador"
                        },
                        {
                            "Nombre":"Test Drive",
                            "Icono": require('./../UI/canvas/carmenu/test_drive.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/test_drive_white.svg'),
                            "Slug":"testdrive",
                            "URL":"https://www.hyundaicolombia.co/testdrive"
                        }
                    ]
                },

                "KONA LIMITED": {
                    "Nombre": "KONA LIMITED",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://view.genial.ly/61ce0fb224849a0d65085168"
                        },
                        {
                            "Nombre":"video de producto",
                            "Icono": require('./../UI/canvas/carmenu/promocionales.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/promocionales_white.svg'),
                            "Slug":"promocionales",
                            "URL":"https://www.youtube.com/embed/hlDDY127mHM"
                        },
                        {
                            "Nombre":"Testimoniales",
                            "Icono": require('./../UI/canvas/carmenu/testimonial.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/testimonial_white.svg'),
                            "Slug":"testimoniales",
                            "URL":"https://www.youtube.com/embed/HsDL7y5-Dpo"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://www.hyundaicolombia.co/cotizador"
                        },
                        {
                            "Nombre":"Test Drive",
                            "Icono": require('./../UI/canvas/carmenu/test_drive.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/test_drive_white.svg'),
                            "Slug":"testdrive",
                            "URL":"https://www.hyundaicolombia.co/testdrive"
                        }
                    ]
                },

                "TUCSON NX4 PREMIUM": {
                    "Nombre": "TUCSON NX4 PREMIUM",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://view.genial.ly/6127bd6b43d0200d121bddb2"
                        },
                        {
                            "Nombre":"video de producto",
                            "Icono": require('./../UI/canvas/carmenu/promocionales.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/promocionales_white.svg'),
                            "Slug":"promocionales",
                            "URL":"https://www.youtube.com/embed/-bqEgz7zQV8"
                        },
                        {
                            "Nombre":"Testimoniales",
                            "Icono": require('./../UI/canvas/carmenu/testimonial.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/testimonial_white.svg'),
                            "Slug":"testimoniales",
                            "URL":"https://www.youtube.com/embed/gFRzdkWNVrU"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://www.hyundaicolombia.co/cotizador"
                        },
                        {
                            "Nombre":"Test Drive",
                            "Icono": require('./../UI/canvas/carmenu/test_drive.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/test_drive_white.svg'),
                            "Slug":"testdrive",
                            "URL":"https://www.hyundaicolombia.co/testdrive"
                        }
                    ]
                },

                "TUCSON NX4 ATTRACTION": {
                    "Nombre": "TUCSON NX4 ATTRACTION",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://view.genial.ly/6127bd6b43d0200d121bddb2"
                        },
                        {
                            "Nombre":"video de producto",
                            "Icono": require('./../UI/canvas/carmenu/promocionales.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/promocionales_white.svg'),
                            "Slug":"promocionales",
                            "URL":"https://www.youtube.com/embed/-bqEgz7zQV8"
                        },
                        {
                            "Nombre":"Testimoniales",
                            "Icono": require('./../UI/canvas/carmenu/testimonial.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/testimonial_white.svg'),
                            "Slug":"testimoniales",
                            "URL":"https://www.youtube.com/embed/gFRzdkWNVrU"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://www.hyundaicolombia.co/cotizador"
                        },
                        {
                            "Nombre":"Test Drive",
                            "Icono": require('./../UI/canvas/carmenu/test_drive.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/test_drive_white.svg'),
                            "Slug":"testdrive",
                            "URL":"https://www.hyundaicolombia.co/testdrive"
                        }
                    ]
                },

                "TUCSON NX4 LIMITED": {
                    "Nombre": "TUCSON NX4 LIMITED",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://view.genial.ly/6127bd6b43d0200d121bddb2"
                        },
                        {
                            "Nombre":"video de producto",
                            "Icono": require('./../UI/canvas/carmenu/promocionales.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/promocionales_white.svg'),
                            "Slug":"promocionales",
                            "URL":"https://www.youtube.com/embed/-bqEgz7zQV8"
                        },
                        {
                            "Nombre":"Testimoniales",
                            "Icono": require('./../UI/canvas/carmenu/testimonial.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/testimonial_white.svg'),
                            "Slug":"testimoniales",
                            "URL":"https://www.youtube.com/embed/gFRzdkWNVrU"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://www.hyundaicolombia.co/cotizador"
                        },
                        {
                            "Nombre":"Test Drive",
                            "Icono": require('./../UI/canvas/carmenu/test_drive.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/test_drive_white.svg'),
                            "Slug":"testdrive",
                            "URL":"https://www.hyundaicolombia.co/testdrive"
                        }
                    ]
                },

                "VENUE PREMIUM MT": {
                    "Nombre": "VENUE",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://view.genial.ly/627ae791afb254001aa32410"
                        },
                        {
                            "Nombre":"video de producto",
                            "Icono": require('./../UI/canvas/carmenu/promocionales.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/promocionales_white.svg'),
                            "Slug":"promocionales",
                            "URL":"https://www.youtube.com/embed/jeTvEPudqxQ"
                        },
                        /*{
                            "Nombre":"Testimoniales",
                            "Icono": require('./../UI/canvas/carmenu/testimonial.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/testimonial_white.svg'),
                            "Slug":"testimoniales",
                            "URL":"https://www.youtube.com/embed/ZOVyJGt6oMQ"
                        },*/
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://www.hyundaicolombia.co/cotizador"
                        },
                        {
                            "Nombre":"Test Drive",
                            "Icono": require('./../UI/canvas/carmenu/test_drive.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/test_drive_white.svg'),
                            "Slug":"testdrive",
                            "URL":"https://www.hyundaicolombia.co/testdrive"
                        }
                    ]
                },

                "STARIA": {
                    "Nombre": "STARIA",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Ver baúl",
                            "Icono": require('./../UI/canvas/carmenu/Ver_baul.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_baul_white.svg'),
                            "Slug":"baul",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://view.genial.ly/6244afc179eb8d001c249f79"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://api.whatsapp.com/send?phone=5717437982&text=WB:%20Buenos%20d%C3%ADas%20me%20ayudar%C3%ADas%20con%20m%C3%A1s%20informaci%C3%B3n."
                        },
                        /*
                        {
                            "Nombre":"video de producto",
                            "Icono": require('./../UI/canvas/carmenu/promocionales.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/promocionales_white.svg'),
                            "Slug":"promocionales",
                            "URL":"https://www.youtube.com/embed/uz0pxz2OG7Y"
                        },
                        {
                            "Nombre":"Testimoniales",
                            "Icono": require('./../UI/canvas/carmenu/testimonial.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/testimonial_white.svg'),
                            "Slug":"testimoniales",
                            "URL":"https://www.youtube.com/embed/ZOVyJGt6oMQ"
                        },
                        
                        {
                            "Nombre":"Test Drive",
                            "Icono": require('./../UI/canvas/carmenu/test_drive.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/test_drive_white.svg'),
                            "Slug":"testdrive",
                            "URL":"https://www.hyundaicolombia.co/testdrive"
                        }
                    */]
                },

                "STARIA PASAJEROS": {
                    "Nombre": "STARIA",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Ver baúl",
                            "Icono": require('./../UI/canvas/carmenu/Ver_baul.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_baul_white.svg'),
                            "Slug":"baul",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://view.genial.ly/6244afc179eb8d001c249f79"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://api.whatsapp.com/send?phone=5717437982&text=WB:%20Buenos%20d%C3%ADas%20me%20ayudar%C3%ADas%20con%20m%C3%A1s%20informaci%C3%B3n."
                        },
                        /*
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                            "SubMenu": [
                                {
                                    "Nombre":"MT | 2022 4X4"
                                },
                                {
                                    "Nombre":"AT | 2022 4X4"
                                }
                            ]
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://www.hyundaicolombia.co/fichas/hb20_getz.pdf"
                        },
                        {
                            "Nombre":"video de producto",
                            "Icono": require('./../UI/canvas/carmenu/promocionales.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/promocionales_white.svg'),
                            "Slug":"promocionales",
                            "URL":"https://www.youtube.com/embed/uz0pxz2OG7Y"
                        },
                        {
                            "Nombre":"Testimoniales",
                            "Icono": require('./../UI/canvas/carmenu/testimonial.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/testimonial_white.svg'),
                            "Slug":"testimoniales",
                            "URL":"https://www.youtube.com/embed/ZOVyJGt6oMQ"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://www.hyundaicolombia.co/cotizador"
                        },
                        {
                            "Nombre":"Test Drive",
                            "Icono": require('./../UI/canvas/carmenu/test_drive.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/test_drive_white.svg'),
                            "Slug":"testdrive",
                            "URL":"https://www.hyundaicolombia.co/testdrive"
                        }
                    */]
                },

                "SUPER METRO ACCENT": {
                    "Nombre": "SUPER METRO ACCENT",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://www.hyundaicolombia.co/fichas/ficha_tecnica_taxis.pdf"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://api.whatsapp.com/send?phone=5717437982&text=WB:%20Buenos%20d%C3%ADas%20me%20ayudar%C3%ADas%20con%20m%C3%A1s%20informaci%C3%B3n."
                        }
                    ]
                },

                "GRAND METRO HB": {
                    "Nombre": "SUPER METRO ACCENT",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://www.hyundaicolombia.co/fichas/ficha_tecnica_taxis.pdf"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://api.whatsapp.com/send?phone=5717437982&text=WB:%20Buenos%20d%C3%ADas%20me%20ayudar%C3%ADas%20con%20m%C3%A1s%20informaci%C3%B3n."
                        }
                    ]
                },

                "GRAND METRO SEDAN": {
                    "Nombre": "SUPER METRO ACCENT",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://www.hyundaicolombia.co/fichas/ficha_tecnica_taxis.pdf"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://api.whatsapp.com/send?phone=5717437982&text=WB:%20Buenos%20d%C3%ADas%20me%20ayudar%C3%ADas%20con%20m%C3%A1s%20informaci%C3%B3n."
                        }
                    ]
                },

                "HD78": {
                    "Nombre": "SUPER METRO ACCENT",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://www.hyundaicolombia.co/static/media/hd78.c9579ed3.pdf"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://api.whatsapp.com/send?phone=5717437982&text=WB:%20Buenos%20d%C3%ADas%20me%20ayudar%C3%ADas%20con%20m%C3%A1s%20informaci%C3%B3n."
                        }
                    ]
                },

                "HD65": {
                    "Nombre": "SUPER METRO ACCENT",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://www.hyundaicolombia.co/static/media/hd65.0857220a.pdf"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://api.whatsapp.com/send?phone=5717437982&text=WB:%20Buenos%20d%C3%ADas%20me%20ayudar%C3%ADas%20con%20m%C3%A1s%20informaci%C3%B3n."
                        }
                    ]
                },

                "HD55": {
                    "Nombre": "SUPER METRO ACCENT",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://www.hyundaicolombia.co/static/media/hd55.171c8ade.pdf"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://api.whatsapp.com/send?phone=5717437982&text=WB:%20Buenos%20d%C3%ADas%20me%20ayudar%C3%ADas%20con%20m%C3%A1s%20informaci%C3%B3n."
                        }
                    ]
                },

                "EX8": {
                    "Nombre": "SUPER METRO ACCENT",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://www.hyundaicolombia.co/static/media/hd55.171c8ade.pdf"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://api.whatsapp.com/send?phone=5717437982&text=WB:%20Buenos%20d%C3%ADas%20me%20ayudar%C3%ADas%20con%20m%C3%A1s%20informaci%C3%B3n."
                        }
                    ]
                },

                "EX10": {
                    "Nombre": "SUPER METRO ACCENT",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://www.hyundaicolombia.co/static/media/hd55.171c8ade.pdf"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://api.whatsapp.com/send?phone=5717437982&text=WB:%20Buenos%20d%C3%ADas%20me%20ayudar%C3%ADas%20con%20m%C3%A1s%20informaci%C3%B3n."
                        }
                    ]
                },

                "GRAND METRO TAXI": {
                    "Nombre": "SUPER METRO ACCENT",
                    "Menu": [
                        {
                            "Nombre":"Ver interior",
                            "Icono": require('./../UI/canvas/carmenu/ver_interior.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ver_interior_white.svg'),
                            "Slug":"interior",
                        },
                        {
                            "Nombre":"Vista 360°",
                            "Icono": require('./../UI/canvas/carmenu/ver_spin360.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/Ver_spin360_White.svg'),
                            "Slug":"360"
                        },
                        {
                            "Nombre":"Ficha técnica",
                            "Icono": require('./../UI/canvas/carmenu/ficha_tecnica.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/ficha_tecnica_white.svg'),
                            "Slug":"ficha",
                            "URL":"https://www.hyundaicolombia.co/static/media/ficha_tecnica_taxis.d32d9167.pdf"
                        },
                        {
                            "Nombre":"Cotizador",
                            "Icono": require('./../UI/canvas/carmenu/cotiza.svg'),
                            "Icono2": require('./../UI/canvas/carmenu/cotiza_white.svg'),
                            "Slug":"cotiza",
                            "URL":"https://api.whatsapp.com/send?phone=5717437982&text=WB:%20Buenos%20d%C3%ADas%20me%20ayudar%C3%ADas%20con%20m%C3%A1s%20informaci%C3%B3n."
                        }
                    ]
                },
            }
        ]
    }
}